class FocusElement extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick() {
    const targetSelector = this.getAttribute('data-target');

    if (!targetSelector) {
      console.warn('focus-element: data-target attribute is missing');
      return;
    }

    // Find the target element
    const targetElement = document.querySelector(targetSelector);

    if (!targetElement) {
      console.warn(`focus-element: Element with selector "${targetSelector}" not found`);
      return;
    }

    // Focus the target element
    targetElement.focus();
  }
}

customElements.define('focus-element', FocusElement);

